export default __webpack_public_path__ + "static/media/home-2.429ee007.png";